<ng-container [formGroup]="form">
	<div
		class="form-control form-field dark-color pr-3"
		[class.full-width]="fullWidth"
		[class.disabled]="isDisabled"
		[tp]="disabledTooltip"
		[tpIsEnabled]="isDisabled && !!disabledTooltip"
		tpPlacement="bottom"
	>
		<div class="range-input-header">
			<mat-label *ngIf="label">{{ label }}</mat-label>
			<mat-form-field *ngIf="showInput" class="range-input--input no-min-width" appearance="fill">
				<input matInput
					   type="number"
					   [value]="currentValue"
					   [min]="min"
					   [max]="max"
					   [step]="step"
					   (change)="updateSlider($event)"
				/>
			</mat-form-field>
		</div>

		<mat-slider
			[min]="min"
			[max]="max"
			[step]="step"
			[thumbLabel]="thumbLabel"
			[tickInterval]="tickInterval"
			[vertical]="vertical"
			[displayWith]="displayWith"
			[formControlName]="controlName"
			[class.full-width]="fullWidth"
			(input)="auditTime > 0 ? onSliderMove($event) : null"
		></mat-slider>
	</div>

	<div *ngIf="hint" class="input-hint">{{ hint }}</div>
</ng-container>
